export function formatFileSize(bytes: number) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / Math.pow(k, i)) * 100) / 100} ${sizes[i]}`;
}

export function isPdfOrImageFile(file: File) {
  return (
    file.type === 'application/pdf' ||
    file.type.startsWith('image/') ||
    Boolean(file.name.match(/\.(pdf|jpg|jpeg|png|gif|bmp|webp|tiff)$/i))
  );
}
